import { useMemo } from 'react';

/**
 * Extracts hashtags from a caption and returns all tags and the first 3 visible tags.
 * @param caption The post caption string
 * @returns { tags, tagsVisible }
 */
export function useTagsDisplay(caption?: string | null) {
  return useMemo(() => {
    const tags = caption?.match(/#([\w_]+)/g) || [];
    const tagsVisible = tags.slice(0, 3);
    return { tags, tagsVisible };
  }, [caption]);
}
